<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.mr_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd">
          <div class="weui-form-preview__item" slot="mr_date">
            <label class="weui-form-preview__label">{{
              customLabel.mr_date || "申请日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.mr_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_proposer">
            <label class="weui-form-preview__label">{{
              customLabel.mr_proposer || "申请人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_proposer
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_apply_deparname">
            <label class="weui-form-preview__label">{{
              customLabel.mr_apply_deparname || "申请部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_apply_deparname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_reason">
            <label class="weui-form-preview__label">{{
              customLabel.mr_reason || "申请理由"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_reason
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_process_mode">
            <label class="weui-form-preview__label">{{
              customLabel.mr_process_mode || "处理方式"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_process_mode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mr_classify">
            <label class="weui-form-preview__label">{{
              customLabel.mr_classify || "评审对象类别"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_classify
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.md_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="qd_sn_code">
              <label class="weui-form-preview__label">{{
                customLabel.iqc_code || "IQC检验单号"
              }}</label>
              <span class="weui-form-preview__value">{{ item.iqc_code }}</span>
            </div>
            <div class="weui-form-preview__item" slot="iqc_class">
              <label class="weui-form-preview__label">{{
                customLabel.iqc_class || "类型"
              }}</label>
              <span class="weui-form-preview__value">
                {{ item.iqc_class }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="iqc_pucode">
              <label class="weui-form-preview__label">{{
                customLabel.iqc_pucode || "采购订单号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.iqc_pucode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_vendname">
              <label class="weui-form-preview__label">{{
                customLabel.md_vendname || "供应商名称"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.md_vendname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_date">
              <label class="weui-form-preview__label">{{
                customLabel.md_date || "来料日期"
              }}</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
                item.md_date
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_prodcode">
              <label class="weui-form-preview__label">{{
                customLabel.md_prodcode || "物料编号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.md_prodcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{
                customLabel.pr_detail || "物料名称"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pr_detail }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_orispeccode">
              <label class="weui-form-preview__label">{{
                customLabel.pr_orispeccode || "型号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pr_orispeccode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_spec">
              <label class="weui-form-preview__label">{{
                customLabel.pr_spec || "规格"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pr_spec }}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_qty">
              <label class="weui-form-preview__label">{{
                customLabel.md_qty || "数量"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.md_qty }}{{ item.pr_unit }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="md_batchcode">
              <label class="weui-form-preview__label">{{
                customLabel.md_batchcode || "批次号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.md_batchcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_use_product">
              <label class="weui-form-preview__label">{{
                customLabel.md_use_product || "使用产品"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.md_use_product
              }}</span>
            </div>
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <custom-layout class="weui-form-preview__bd">
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_describe"
            slot="mr_describe"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_describe || "问题描述"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_describe
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_risk"
            slot="mr_risk"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_risk || "潜在风险"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_risk
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_order"
            slot="mr_order"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_order || "影响订单"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_order
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_prodcode"
            slot="mr_prodcode"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_prodcode || "影响产品号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_prodcode
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_order_qty"
            slot="mr_order_qty"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_order_qty || "影响订单数量"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_order_qty
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_stock_qty"
            slot="mr_stock_qty"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_stock_qty || "材料库存数"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_stock_qty
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_work_qty"
            slot="mr_work_qty"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_work_qty || "材料在制数"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_work_qty
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_pr_qty"
            slot="mr_pr_qty"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_pr_qty || "在途成品数"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_pr_qty
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_semi_stock_qty"
            slot="mr_semi_stock_qty"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_semi_stock_qty || "半成品库存数"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_semi_stock_qty
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_semi_work_qty"
            slot="mr_semi_work_qty"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_semi_work_qty || "半成品在制数"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_semi_work_qty
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_pr_stock_qty"
            slot="mr_pr_stock_qty"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_pr_stock_qty || "成品库存数"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_pr_stock_qty
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_pr_work_qty"
            slot="mr_pr_work_qty"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_pr_work_qty || "成品在制数"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_pr_work_qty
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="form-detail-preview_num">意见</div>
        <div class="weui-form-preview__bd">
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_quality_opinion"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_quality_opinion || "品质意见"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_quality_opinion
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_quality_signature"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_quality_signature || "签名"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_quality_signature
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.mr_quality_date">
            <label class="weui-form-preview__label">{{
              customLabel.mr_quality_date || "日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.mr_quality_date
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_quality_content"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_quality_content || "内容"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_quality_content
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_engine_opinion"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_engine_opinion || "工程意见"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_engine_opinion
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_engine_signature"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_engine_signature || "签名"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_engine_signature
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.mr_engine_date">
            <label class="weui-form-preview__label">{{
              customLabel.mr_engine_date || "日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.mr_engine_date
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_engine_content"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_engine_content || "内容"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_engine_content
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_product_opinion"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_product_opinion || "产品意见"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_product_opinion
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_product_signature"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_product_signature || "签名"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_product_signature
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.mr_product_date">
            <label class="weui-form-preview__label">{{
              customLabel.mr_product_date || "日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.mr_product_date
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_product_content"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_product_content || "内容"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_product_content
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_purchase_opinion"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_purchase_opinion || "采购意见"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_purchase_opinion
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_purchase_signature"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_purchase_signature || "签名"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_purchase_signature
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_purchase_date"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_purchase_date || "日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.mr_purchase_date
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_purchase_content"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_purchase_content || "内容"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_purchase_content
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.mr_plan_opinion">
            <label class="weui-form-preview__label">{{
              customLabel.mr_plan_opinion || "计划意见"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_plan_opinion
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_plan_signature"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_plan_signature || "签名"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_plan_signature
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.mr_plan_date">
            <label class="weui-form-preview__label">{{
              customLabel.mr_plan_date || "日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.mr_plan_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.mr_plan_content">
            <label class="weui-form-preview__label">{{
              customLabel.mr_plan_content || "内容"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_plan_content
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_production_opinion"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_production_opinion || "生产意见"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_production_opinion
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_production_signature"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_production_signature || "签名"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_production_signature
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_production_date"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_production_date || "日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.mr_production_date
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_production_content"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_production_content || "内容"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_production_content
            }}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="form-detail-preview_num">结论</div>
        <div class="weui-form-preview__bd">
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_final_conclusion"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_final_conclusion || "最终结论"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_final_conclusion
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_final_content"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_final_content || "内容"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_final_content
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.mr_affiliation">
            <label class="weui-form-preview__label">{{
              customLabel.mr_affiliation || "责任归属"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_affiliation
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.mr_inform">
            <label class="weui-form-preview__label">{{
              customLabel.mr_inform || "通知客户"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_inform
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.mr_measure">
            <label class="weui-form-preview__label">{{
              customLabel.mr_measure || "纠正或预防措施"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_measure
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="form-detail-preview_num">跟进</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.mr_dutyer">
            <label class="weui-form-preview__label">{{
              customLabel.mr_dutyer || "责任人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_dutyer
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.mr_duty_deparname"
          >
            <label class="weui-form-preview__label">{{
              customLabel.mr_duty_deparname || "责任部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_duty_deparname
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.mr_finish_time">
            <label class="weui-form-preview__label">{{
              customLabel.mr_finish_time || "计划完成时间"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.mr_finish_time
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.mr_cost">
            <label class="weui-form-preview__label">{{
              customLabel.mr_cost || "工时费用统计"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mr_cost
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{
              customLabel.creatorName || "录入人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{
              customLabel.createTime || "录入日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.createTime
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/storage/mrb/",
      caller: "Mrb",
      xtype: "stock-mrb-formpanel",
    };
  },
};
</script>